import * as React from 'react';

const GooglePay = (props: React.ComponentProps<'svg'>) => (
  <svg
    viewBox="0 0 58 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" fill="white" />
    <rect x="0.5" y="0.5" width="57" height="39" rx="5.5" stroke="#E5E7EB" />
    <path
      d="M44.5193 23.55H44.5477L46.9109 17.6193H48.5711L43.4656 29.51H41.8904L43.7889 25.3508L40.4383 17.6193H42.0994L44.5193 23.55ZM36.5281 17.3498C37.6575 17.3498 38.5501 17.6573 39.2049 18.2639C39.8596 18.8704 40.1824 19.7178 40.1824 20.7863V25.8801H38.7205V24.7346H38.6541C38.0183 25.6779 37.183 26.1496 36.1297 26.1496C35.2378 26.1496 34.4785 25.8801 33.8807 25.341C33.2923 24.8404 32.9603 24.0984 32.9793 23.3186C32.9794 22.4619 33.3016 21.7878 33.9373 21.2776C34.5731 20.7673 35.4274 20.5169 36.4901 20.5168C37.4011 20.5168 38.1419 20.6904 38.7303 21.0178V20.6613C38.7302 20.1319 38.5028 19.631 38.1043 19.2844C37.6962 18.9185 37.1736 18.717 36.6326 18.717C35.7786 18.7171 35.1046 19.083 34.6111 19.8147L33.2635 18.9572C33.9847 17.8886 35.0763 17.3499 36.5281 17.3498ZM29.2879 13.8059C30.2652 13.7867 31.2144 14.1626 31.907 14.8557C33.2924 16.1651 33.3779 18.3701 32.0779 19.7854L31.907 19.9582C31.1954 20.6417 30.3221 20.9884 29.2879 20.9885H26.7635V25.8801H25.2352V13.8059H29.2879ZM36.7283 21.7688C36.1115 21.7688 35.5893 21.9225 35.1717 22.2209C34.7636 22.5194 34.5545 22.8953 34.5545 23.3479C34.5545 23.7521 34.7444 24.1275 35.0574 24.3586C35.3991 24.6281 35.8169 24.7725 36.244 24.7629C36.8892 24.7629 37.5062 24.5031 37.9617 24.0412C38.4647 23.5599 38.7214 22.9917 38.7215 22.3371C38.2469 21.952 37.5826 21.7591 36.7283 21.7688ZM26.7635 19.5061H29.326C29.8954 19.5253 30.4456 19.294 30.8348 18.8801C31.632 18.0425 31.6135 16.6947 30.7879 15.886C30.3987 15.5008 29.8765 15.2893 29.326 15.2893H26.7635V19.5061Z"
      fill="#3C4043"
    />
    <path
      d="M21.4882 19.9299C21.4882 19.4581 21.4502 18.9863 21.3743 18.5242H14.9305V21.1912H18.6221C18.4703 22.0481 17.9768 22.8183 17.2556 23.2997V25.0328H19.4573C20.7479 23.8293 21.4882 22.0481 21.4882 19.9299Z"
      fill="#4285F4"
    />
    <path
      d="M14.9308 26.7081C16.7719 26.7081 18.3282 26.0919 19.4576 25.0328L17.2559 23.2997C16.639 23.7233 15.8513 23.964 14.9308 23.964C13.1466 23.964 11.6377 22.7413 11.0968 21.1045H8.82861V22.8953C9.98641 25.235 12.3495 26.7081 14.9308 26.7081Z"
      fill="#34A853"
    />
    <path
      d="M11.097 21.1045C10.8123 20.2476 10.8123 19.3136 11.097 18.4471V16.6659H8.82851C7.85087 18.6204 7.85087 20.9312 8.82851 22.8857L11.097 21.1045Z"
      fill="#FBBC04"
    />
    <path
      d="M14.9308 15.5876C15.9083 15.5683 16.8478 15.9438 17.5501 16.6274L19.505 14.644C18.2618 13.4694 16.6295 12.8243 14.9308 12.8436C12.3495 12.8436 9.98641 14.3263 8.82861 16.6659L11.0968 18.4568C11.6377 16.8103 13.1466 15.5876 14.9308 15.5876Z"
      fill="#EA4335"
    />
  </svg>
);

export default GooglePay;
